import {
  Avatar,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Toolbar
} from '@mui/material';
import { useState } from 'react';
import * as React from 'react';

import Box from '@mui/material/Box';

import Typography from '@mui/material/Typography';

import Grid from '@mui/material/Grid';
import { TextForm } from '../../../components/TextBox';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetGroupByUserQuery, useGetUserIdQuery, usePostUserChangePasswordMutation, usePostUserSaveMutation } from '../../../store/api/userApi';
import { useGetBusinessByUserQuery } from '../../../store/api/businessApi';
import { useForm } from 'react-hook-form';
import { DataGrid } from '@mui/x-data-grid';
import { useEffect } from 'react';
import { dataColumn } from '../../../components/DataColumn';
import SelectForm from '../../../components/SelectBox/SelectForm';
import { genderArray, themeArray } from '../../../constDatas/constDatas';
import UploadPhoto from '../../../components/UploadPhoto/UploadPhoto';
import { createBaseFileQuery } from '../../../store/helper/createBaseQuery';
import { hideSaveDialog } from '../../../store/slice/dialogSlice';
import { showErrorToast, showSuccessToast } from '../../../constToast/constToast';
import { useDispatch } from 'react-redux';
import SaveDialog from '../../../components/Dialog/SaveDialog';
import PasswordForm from '../../../components/TextBox/PasswordForm';
import ConfirmPasswordForm from '../../../components/TextBox/ConfirmPasswordForm';
import { toast } from 'react-toastify';


const UserCard = () => {

  const { dataId } = useParams()
  const navigate = useNavigate();

  const { data: groupInfo, isLoading: groupInfoLoading } = useGetGroupByUserQuery(dataId)
  const { data: userInfo, isLoading: userInfoLoading } = useGetUserIdQuery(dataId)
  const { data: businessUnitData } = useGetBusinessByUserQuery();
  const [addSave] = usePostUserSaveMutation()

  const [groupTableData, setGroupTableData] = useState([])

  const {
    handleSubmit,
    control,
    formState: { errors },
    reset, watch
  } = useForm({ mode: 'onBlur' })


  useEffect(() => {
    reset({
      ...userInfo?.data,
      defaultBusinessUnitId: userInfo?.data?.defaultBusinessUnitId || businessUnitData?.data[0]?.businessUnitId
    })
  }, [reset, userInfo, businessUnitData])

  useEffect(() => {
    if (!groupInfoLoading) {
      setGroupTableData(groupInfo?.data?.filter(x => x.userInGroup === true))
    }
  }, [groupInfoLoading, groupInfo])


  const [photoUrl, setPhotoUrl] = useState('');
  const [signatureUrl, setSignatureUrl] = useState('')


  // Api
  const [photo, setPhoto] = useState(null)
  const [userPhotoIsDeleted, setUserPhotoIsDeleted] = useState(false)
  const [signature, setSignature] = useState(null)
  const [signatureIsDeleted, setSignatureIsDeleted] = useState(false)



  const fetchPhoto = async () => {
    if (userInfo?.data?.userPhoto) {
      const dataPhoto = await createBaseFileQuery(userInfo?.data?.userPhoto)
      setPhotoUrl(URL.createObjectURL(dataPhoto))
    }
  }

  useEffect(() => {
    fetchPhoto()
  }, [])

  const fetchSignature = async () => {
    if (userInfo?.data?.signaturePhoto) {
      const dataSignature = await createBaseFileQuery(userInfo?.data?.signaturePhoto)
      setSignatureUrl(URL.createObjectURL(dataSignature))
    }
  }

  useEffect(() => {
    fetchSignature()
  }, [])


  const dispatch = useDispatch();

  const onSubmit = async (data) => {
    const formData = new FormData()

    formData.append('userPhoto', photo)
    formData.append('signaturePhoto', signature)

    formData.append('userPhotoIsDeleted', userPhotoIsDeleted)
    formData.append('signaturePhotoIsDeleted', signatureIsDeleted)

    delete data.userPhoto
    delete data.signaturePhoto


    for (const key in data) {
      formData.append(key, data[key])
    }

    const addData = await addSave(formData)



    if (addData.data?.statusCode === 200) {
      showSuccessToast('Save Succesfully!')
      if (dataId === '0') {
        navigate('/users')
        dispatch(hideSaveDialog())
      }
    } else {
      showErrorToast(`Please Fill in Data !`)
      dispatch(hideSaveDialog())
    }
  }


  useEffect(() => {
    if (!userInfoLoading && userInfo) {
      setPhotoUrl(userInfo?.data?.userPhoto)
      setSignatureUrl(userInfo?.data?.signaturePhoto)
    }
  }, [userInfoLoading, userInfo])


  //////////
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const [addChangePassword] = usePostUserChangePasswordMutation();
  async function onSubmitPassword(data) {

    const addData = await addChangePassword({

      password: data.password,
      confirmPassword: data.confirmPassword,
      userId: data.id,
    })

    if (addData?.data?.statusCode === 200) {
      toast.success('Changed Password');
      handleClose();
      reset()
    } else {
      toast.error('Error');
    }

  };

  return (
    <>
      <Toolbar />
      <Grid container spacing={3} display='flex' justifyContent='space-around'>
        <Grid item xs={12} sm={12} md={12} lg={2.5} xl={2}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12}>
              <Card>
                <CardContent>
                  <Box sx={{ alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
                    <Avatar
                      src={photoUrl || ''}
                      sx={{
                        height: 128,
                        mb: 2,
                        width: 128
                      }}
                    />
                    <Typography
                      color="textPrimary"
                      gutterBottom
                      variant="h5"
                    >
                      {userInfo?.data?.fullName}
                    </Typography>
                    <Typography
                      color="textSecondary"
                      variant="body2"
                    >
                      {userInfo?.data?.email}
                    </Typography>
                  </Box>

                </CardContent>

                <Divider />
                <CardActions>
                  <Button
                    color="primary"
                    fullWidth
                    variant="text"
                  >
                    <UploadPhoto label='Upload Photo' setFile={setPhoto} setUrl={setPhotoUrl} setIsDeleted={setUserPhotoIsDeleted} />
                  </Button>
                </CardActions>
              </Card>
            </Grid>

            <Grid item xs={12} sm={12} md={12} mt={2}>
              <Card>
                <CardContent sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-around' }}>
                  <Box >
                    <Avatar
                      src={signatureUrl || ''}
                      sx={{
                        height: 40,
                        width: 40
                      }}
                    >
                      S
                    </Avatar>
                  </Box>
                  <Box>
                    <Button
                      color="primary"
                      fullWidth
                      variant="text"
                    >
                      <UploadPhoto label='Upload Signature Photo' setFile={setSignature} setUrl={setSignatureUrl} setIsDeleted={setSignatureIsDeleted} />
                    </Button>
                  </Box>
                </CardContent>

              </Card>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={9.5} xl={9}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Card>
                <Grid container spacing={3} display="flex" justifyContent='space-between'>
                  <Grid item xs={12} md={12} lg={5.5} >
                    <CardHeader
                      title="General"
                    />
                    <Divider />
                    <form onSubmit={handleSubmit(onSubmit)} noValidate>
                      <CardContent>

                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={6} md={6} lg={6} >
                            <TextForm
                              label="User Name"
                              dynamicField="userName"
                              control={control}
                              errors={errors}
                              required={true}
                              min={3}
                              max={40}
                              disabled={true}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} lg={6} >
                            <TextForm
                              label="Email Address"
                              dynamicField="email"
                              control={control}
                              errors={errors}
                              required={true}
                              min={3}
                              max={40}
                              disabled={true}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} lg={6} >
                            <TextForm
                              label="Full Name"
                              dynamicField="fullName"
                              control={control}
                              errors={errors}
                              required={true}
                              min={3}
                              max={40}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} lg={6} >
                            <TextForm
                              label="Description"
                              dynamicField="description"
                              control={control}
                              errors={errors}
                              required={false}
                              min={3}
                              max={40}
                            />
                          </Grid>

                          {userInfo?.data?.userTypeId === 1 && (
                            <Grid item xs={12} sm={6} md={6} lg={6} >
                              <TextForm
                                label="ERP User"
                                dynamicField="erpUser"
                                control={control}
                                errors={errors}
                                required={false}
                                min={3}
                                max={40}
                              />
                            </Grid>)}


                          <Grid item xs={12} sm={6} md={6} lg={6} >
                            <SelectForm
                              label="Gender"
                              id="id"
                              name="gender"
                              control={control}
                              errors={errors}
                              disabled={false}
                              data={genderArray}
                              dynamicField="gender"
                              required={true}
                            />
                          </Grid>
                          {/* <Grid item xs={12} sm={6} md={6} lg={6} >
                            <SelectForm
                              label="Theme"
                              id="theme"
                              name="theme"
                              control={control}
                              errors={errors}
                              disabled={false}
                              data={themeArray}
                              dynamicField="theme"
                            />
                          </Grid> */}
                          <Grid item xs={12} sm={6} md={6} lg={6} hidden >
                            <SelectForm
                              label="Business Unit"
                              id="businessUnitId"
                              name="businessUnitName"
                              control={control}
                              errors={errors}
                              disabled={false}
                              data={businessUnitData?.data}
                              dynamicField="defaultBusinessUnitId"
                            />
                          </Grid>
                          <Grid item xs={12} flex={1} display='flex' justifyContent='flex-end'>
                            <Button variant='contained' onClick={() => setOpen(true)}>Change Password</Button>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </form>

                  </Grid>

                  <Grid item xs={0.3} sx={{ display: 'flex', textAlign: 'center', justifyContent: 'space-around', alignItems: 'center', mt: 2, mb: 2 }}>
                    <Divider orientation="vertical" flexItem></Divider>
                  </Grid>

                  {userInfo?.data?.userTypeId === 1 && (
                    <Grid item xs={12} md={12} lg={5.5}>
                      <CardHeader
                        title="Group Info"
                      />
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item xs={12}>
                            <Box sx={{ height: 230, width: '100%' }}>
                              <DataGrid
                                rows={groupTableData || []}
                                columns={columns}
                                getRowId={row => row.groupUserId}
                                hideFooter
                                rowHeight={30}
                              />
                            </Box>
                          </Grid>
                        </Grid>

                      </CardContent>
                    </Grid>
                  )}

                </Grid>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <div>
        <Dialog open={open} fullWidth onClose={handleClose}>
          <DialogTitle sx={{ fontSize: 24 }}>
            Change Password
          </DialogTitle>
          <DialogContent>
            <DialogContentText sx={{ fontSize: 16 }}>
              Want to change your password?
            </DialogContentText>
            <form onSubmit={handleSubmit(onSubmitPassword)}>
              <Grid container spacing={3}>
                <Grid item xs={6} mt={1}>
                  <PasswordForm control={control} errors={errors}
                    dynamicField='password' label='Password' required={true} min={7} max={20} />
                </Grid>
                <Grid item xs={6} mt={1}>
                  <ConfirmPasswordForm control={control} errors={errors} dynamicField='confirmPassword'
                    label='Confirm Password' password={watch('password')} />
                </Grid>
              </Grid>
            </form>
          </DialogContent>
          <DialogActions>
            <Button variant='contained' onClick={handleSubmit(onSubmitPassword)}>Set Password</Button>
            <Button variant="outlined" onClick={handleClose} sx={{ color: 'gray', borderColor: '#D3D3D3' }}>Cancel</Button>
          </DialogActions>
        </Dialog>

      </div>
      <SaveDialog handleSave={handleSubmit(onSubmitPassword)} text="User Card" />
    </>
  );
};

export default UserCard;

const columns = [
  dataColumn('groupName', 'Group Name', 150),
];